/**
 * ReporteCalificacionesModal Component
 * 
 * Modal para mostrar el reporte completo de calificaciones de un grupo.
 * Incluye todas las evaluaciones y promedios finales.
 * 
 * Basado en Image 18 del diseño
 */

import React, { useState, useEffect } from "react";
import { generateReporteCalificacionesPDF } from "../../utils/generateReporteCalificacionesPDF";
import styles from "./RegistroCalificaciones.module.css";


// Ahora recibimos estudiantes reales por props

// Ya no se necesita mapearCalificacionesPorParcial, los datos vienen listos por props


// Función para redondear el promedio según la escala dada (0 a 10)
function redondearPromedio(valor) {
  if (valor === 0) return 0;
  if (valor > 0 && valor < 5.9) return 5;
  if (valor >= 5.9 && valor < 6.9) return 6;
  if (valor >= 6.9 && valor < 7.5) return 7;
  if (valor >= 7.5 && valor < 8.5) return 8;
  if (valor >= 8.5 && valor < 9.5) return 9;
  if (valor >= 9.5 && valor <= 10) return 10;
  return 0; // Si está fuera de rango, regresa 0
}

function ReporteCalificacionesModal({ grupo, estudiantes = [], onCerrar }) {
    // Depuración: mostrar el objeto grupo en consola
    console.log('Grupo recibido en ReporteCalificacionesModal:', grupo);
  // Handler para descargar PDF
  const handleDescargarPDF = async () => {
    await generateReporteCalificacionesPDF({ grupo, estudiantes, descargar: true });
  };

  // Cerrar modal con ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onCerrar();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onCerrar]);

  return (
    <div className={styles.modalOverlay} onClick={onCerrar}>
      <div className={styles.modalReporte} onClick={(e) => e.stopPropagation()}>
        {/* Header del Modal */}
        <div className={styles.modalReporteHeader}>
          <h2 className={styles.modalReporteTitulo}>Reporte de Calificaciones</h2>
          <button className={styles.modalCerrarButton} onClick={onCerrar}>
            ✕
          </button>
        </div>

        {/* Información del Grupo */}
        <div className={styles.modalReporteInfo}>
          <div className={styles.infoColumna}>
            <p><strong>Asesor:</strong> {grupo?.asesor_nombre || grupo?.asesor || 'Sin asesor'}</p>
            <p><strong>Grupo:</strong> {grupo?.codigo} - {grupo?.nombre}</p>
          </div>
          <div className={styles.infoColumna}>
            <p><strong>Periodo:</strong> {grupo?.ciclo || '—'}</p>
            <p><strong>Programa:</strong> {grupo?.programa_academico || grupo?.programa || 'Sin programa'}</p>
          </div>
        </div>

        {/* Tabla de Reporte */}
        <div className={styles.modalReporteTablaContainer}>
          <table className={styles.modalReporteTabla}>
            <thead>
              <tr className={styles.modalReporteTablaHeader}>
                <th rowSpan="2">Estudiante</th>
                <th rowSpan="2">Matrícula</th>
                <th colSpan="3">Parcial 1</th>
                <th colSpan="3">Parcial 2</th>
                <th colSpan="3">Parcial 3</th>
                <th rowSpan="2">Promedio</th>
                <th rowSpan="2">Observaciones</th>
              </tr>
              <tr className={styles.modalReporteTablaSubheader}>
                <th>A1</th>
                <th>Ex1</th>
                <th>Parcial 1</th>
                <th>A2</th>
                <th>Ex2</th>
                <th>Parcial 2</th>
                <th>A3</th>
                <th>Ex3</th>
                <th>Parcial 3</th>
              </tr>
            </thead>
            <tbody>
              {estudiantes.map((estudiante) => {
                const p1 = parseFloat(estudiante.parcial1) || 0;
                const p2 = parseFloat(estudiante.parcial2) || 0;
                const p3 = parseFloat(estudiante.parcial3) || 0;
                const promedioSinRedondear = (p1 + p2 + p3) / 3;
                const promedio = redondearPromedio(promedioSinRedondear);
                return (
                  <tr key={estudiante.id || estudiante.id_estudiante_grupo} className={styles.modalReporteTablafila}>
                    <td className={styles.estudianteNombreReporte}>{estudiante.nombre}</td>
                    <td>{estudiante.matricula}</td>
                    <td><input type="number" className={styles.inputReporte} value={''} readOnly /></td>
                    <td><input type="number" className={styles.inputReporte} value={''} readOnly /></td>
                    <td><input type="number" className={styles.inputReporte} value={estudiante.parcial1 || ''} readOnly /></td>
                    <td><input type="number" className={styles.inputReporte} value={''} readOnly /></td>
                    <td><input type="number" className={styles.inputReporte} value={''} readOnly /></td>
                    <td><input type="number" className={styles.inputReporte} value={estudiante.parcial2 || ''} readOnly /></td>
                    <td><input type="number" className={styles.inputReporte} value={''} readOnly /></td>
                    <td><input type="number" className={styles.inputReporte} value={''} readOnly /></td>
                    <td><input type="number" className={styles.inputReporte} value={estudiante.parcial3 || ''} readOnly /></td>
                    <td><input type="number" className={styles.inputReportePromedio} value={promedio} readOnly /></td>
                    <td style={{ padding: '8px' }}>
                      <input 
                        type="text" 
                        className={styles.inputReporte} 
                        value={estudiante.observaciones || ''} 
                        readOnly 
                        style={{ width: '100%', minWidth: '150px' }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Botones de acción */}
        <div className={styles.modalReporteBotones}>
          <button className={styles.modalCerrarButtonSecundario} onClick={onCerrar}>
            CERRAR
          </button>
          <button className={styles.modalImprimirButton} onClick={handleDescargarPDF}>
            DESCARGAR PDF
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReporteCalificacionesModal;
